import { render, staticRenderFns } from "./modal_edit_keyword.vue?vue&type=template&id=ced998fa&scoped=true"
import script from "./modal_edit_keyword.vue?vue&type=script&lang=js"
export * from "./modal_edit_keyword.vue?vue&type=script&lang=js"
import style0 from "./modal_edit_keyword.vue?vue&type=style&index=0&id=ced998fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced998fa",
  null
  
)

export default component.exports